import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export default function useQueryParams() {
  const search = useLocation().search
  const queryParams = useMemo(() => {
    return new URLSearchParams(search)
  }, [search])

  return queryParams
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useQueryParams/index.js